//base url
// export const BASE_URL = "http://3.7.129.129/fc-core";
// export const BASE_URL = "https://api.scalent.in/fc-core";
// export const BASE_URL = "http://localhost:9025/fc-core";
export const BASE_URL = "https://api.falcon-co.com/fc-core";

// login API
export const LOGIN = `${BASE_URL}/login`;

// logout
export const LOGOUT = `${BASE_URL}/logout`;

//user
export const USER = `${BASE_URL}/user/`;

//Job Type
export const JOB_TYPE_LIST = `${BASE_URL}/job-type/list`;

//region
export const REGION_LIST = `${BASE_URL}/region/list`;

//job
export const JOB = `${BASE_URL}/job/`;
export const JOB_LIST = `${BASE_URL}/job/list/customer`;

//forgot password
export const FORGET_PASSWORD = `${BASE_URL}/forget`;

//validate uuid:
export const VALIDATE_UUID_LINK = `${BASE_URL}/validate-link/`;

//reset-password
export const RESET_PASSWORD = `${BASE_URL}/reset-password`;

//job timeline
export const JOB_TIME_LINE = `${BASE_URL}/job-time-line/`;

//resend email invite to user/customer
export const RESEND_EMAIL_INVITE = `${BASE_URL}/user/resend-email/`;

//quotation download
export const QUOTATION_DOWNLOAD = `${BASE_URL}/quotation/download/`;

// Technical report
export const TECHNICAL_REPORT = `${BASE_URL}/technical-report/`;

//quotation
export const QUOTATION = `${BASE_URL}/quotation/`;
export const QUOTATION_DETAILS = `${BASE_URL}/quotation/detail/`;

//payment
export const VALIDATE_QUOTATION_UUID = `${BASE_URL}/quotation/validate`;
export const APPROVE_AND_REJECT_QUOTATION = `${BASE_URL}/quotation/review`;
export const RECORD_BANK_TRANSFER = `${BASE_URL}/quotation/record-bank-transfer`;


// Cancel Job
export const CANCEL_JOB = `${BASE_URL}/job/cancel`;

// Equipment Manual
export const EQUIPMENT_MANUAL = `${BASE_URL}/job/manual`;

// Job Media
export const GET_JOB_MEDIA = `${BASE_URL}/job-media/list`;

// Service History
export const SERVICE_HISTORY = `${BASE_URL}/job/service/history`;

//Job Completed Rework
export const JOB_COMPLETED_OR_REWORK = `${BASE_URL}/job/completed-rework`;

//Download Job Report
export const DOWNLOAD_JOB_REPORT = `${BASE_URL}/job/download-report`;

// Get CheckoutId
export const GENERATE_CHECKOUT_ID = `${BASE_URL}/payments/create-checkout`;

//Download Payment Receipt
export const DOWNLOAD_PAYMENT_RECEIPT = `${BASE_URL}/payments/receipt`;

//Get Payment Status
export const GET_PAYMENT_STATUS = `${BASE_URL}/payments/verify`;

// download job media
export const DOWNLOAD_JOB_MEDIA = `${BASE_URL}/job-media/download`;

// download product manual
export const DOWNLOAD_PRODUCT_MANUAL = `${BASE_URL}/product/download-manual`;

// download equipment invoice
export const DOWNLOAD_EQUIPMENT_INVOICE = `${BASE_URL}/customer-equipment/download-invoice`;

// reopen job
export const REOPEN_JOB = `${BASE_URL}/job/reopen`;

//assign location to sub user
export const ASSIGN_LOCATION_SUB_USER = `${BASE_URL}/user-location/`;

//quotation listing
export const CUSTOMER_QUOTATION_LIST = `${BASE_URL}/quotation/list/customer`;


//send otp
export const SEND_OTP = `${BASE_URL}/send-otp`;